import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Button from '@material-ui/core/Button'
import { getMonthSuffix } from '../utils/helpers'

import t from '../utils/lang'

import FlexOptionDataDialog from './FlexOptionDataDialog'

class OptionExpansionPanel extends Component {
	state = {
    expanded: null,
    lang: 'en',
    openFlexGeneralInfoDialog: false,
    openFlexOptionDataDialog: false,
  }

  componentDidMount() {
    const { lang } = this.props

    this.setState({ lang: lang ? lang : 'en' })
  }

  handleFlexOptionDataDialogOpen = (event) => {
    this.setState({ openFlexOptionDataDialog: true });
  }

  handleFlexOptionDataDialogClose = () => {
    this.setState({ openFlexOptionDataDialog: false });
  }

  render() {
    const { lang, openFlexOptionDataDialog } = this.state
    const { id, data, leasePeriods, index, statusId, classes } = this.props
    const option = data && data.options ? data.options[index] : null;
    const proposalSubmitted = statusId === 3 ? true : false;
    const feeContainers = leasePeriods.length;

    return (
    	<Fragment>
	      <ExpansionPanel defaultExpanded={!feeContainers}>
	        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
	          <Typography className={classes.panelHeader}>{lang && `${t[lang].option} ${index+1}`}</Typography>
	          {/*<Typography className={classes.panelAnswerQuestions}>{`${answeredQuestions.option} ${t[lang].of} ${option.length} ${t[lang].answered}`}</Typography>*/}
	        </ExpansionPanelSummary>
					{feeContainers
					? <ExpansionPanelDetails className={classes.questionList}>
						<div className={classes.dataRow}>
	            <Typography className={classes.dataLabel}>{t[lang].setupFee}</Typography>
	            <Typography className={classes.dataValue}>{option ? option.setupFee : ''}</Typography>
	          </div>

	          <div className={classes.dataRow}>
							<Typography className={classes.dataLabelFull}>{t[lang].monthlyRentFee}</Typography>
							{option && option.rentFee && Array(feeContainers).fill(null).map((el, key) => <Fragment key={key}>
								<Typography className={classes.dataLabelIndent}>{leasePeriods[key] ? leasePeriods[key].value + ' ' + getMonthSuffix(leasePeriods[key].value, lang) : ''}</Typography>
								<Typography className={classes.dataValueIndent}>{option.rentFee[key]}</Typography>
							</Fragment>
							)}
	          </div>

						<div className={classes.dataRow}>
							<Typography className={classes.dataLabelFull}>{t[lang].exitFee}</Typography>
							{option && option.exitFee && Array(feeContainers).fill(null).map((el, key) => <Fragment key={key}>
								<Typography className={classes.dataLabelIndent}>{leasePeriods[key] ? leasePeriods[key].value + ' ' + getMonthSuffix(leasePeriods[key].value, lang) : ''}</Typography>
								<Typography className={classes.dataValueIndent}>{option.exitFee[key]}</Typography>
							</Fragment>
							)}
	          </div>

						<div className={classes.dataRow}>
	            <Typography className={classes.dataLabel}>{t[lang].parkingFee}</Typography>
	            <Typography className={classes.dataValue}>{option ? option.parkingFee : ''}</Typography>
	          </div>

	          <div className={classes.dataRow}>
	            <Typography className={classes.dataLabel}>{t[lang].numberOfWorkstations}</Typography>
	            <Typography className={classes.dataValue}>{option ? option.workstations : ''}</Typography>
	          </div>

	          <div className={classes.dataRow}>
	            <Typography className={classes.dataLabel}>{t[lang].deposit}</Typography>
	            <Typography className={classes.dataValue}>{option ? option.deposit : ''}</Typography>
	          </div>

	          <div className={classes.dataRow}>
	            <Typography className={classes.dataLabel}>{t[lang].comment}</Typography>
	            <Typography className={classes.dataValue}>{option ? option.comment : ''}</Typography>
	          </div>
	        </ExpansionPanelDetails>
						: <ExpansionPanelDetails>
							<Typography>{t[lang].noLeasePeriods}</Typography>
						</ExpansionPanelDetails>
					}
	        {feeContainers && <ExpansionPanelActions>
	          <Button size="small" color="primary" onClick={event => this.handleFlexOptionDataDialogOpen(event)} disabled={proposalSubmitted}>
	            {t[lang].edit}
	          </Button>
	        </ExpansionPanelActions>}
	      </ExpansionPanel>

	      <FlexOptionDataDialog index={index} open={openFlexOptionDataDialog} handleClose={this.handleFlexOptionDataDialogClose} />
      </Fragment>
    );
  }
}

OptionExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

function mapStateToProps ({ rfpData, questions }) {
  const { lang, id, statusId, flexData, leasePeriods } = rfpData

  const categorizedQuestions = {
    //'option': Object.values(questions).filter((q) => q.categoryId === "6"),
  }

  const answeredQuestions = {
    //'option': categorizedQuestions.option.filter((q) => q.answer !== '').length,
  }

  const unansweredQuestions = {
    //'option': categorizedQuestions.option.length - answeredQuestions.option,
  }

  return {
    general: categorizedQuestions.general,
    //option: categorizedQuestions.option,
    answeredQuestions,
    unansweredQuestions,
		leasePeriods,
    lang,
    id,
    statusId,
    data: flexData
  }
}

export default connect(mapStateToProps)(OptionExpansionPanel)


// WEBPACK FOOTER //
// ./src/components/OptionExpansionPanel.js